const _ = require("lodash");

import Vue from "vue";
import Vuex from "vuex";

import API from "../api";

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		return await callback();
	} catch (e) {
		if (e.response) throw e.response.data;
		throw e
	}
}

const UserModule = {
	namespaced: true,
	state: {
		userInfo: {}
	},
	mutations: {
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		cleanUserInfo(state) {
			state.userInfo = {};
		},
		updateProfile(state, data) {
			_.assign(state.userInfo, data);
		},
		updateJob(state, data) {
			state.userInfo.jobs = _.cloneDeep(data);
		},
		deleteJob(state, id) {
			if (id) {
				_.remove(state.userInfo.jobs, function (job) {
					return job.id == id;
				});
			}
		}
	},
	actions: {
		async signUp({ }, data) {
			try {
				let res = await API.SignUp(data);
				return res;
			} catch (e) {
				throw e.response.data;
			}
		},
		async registerProfile({ }, data) {
			try {
				await API.RegisterProfile(data);
			} catch (e) {
				throw e.response.data;
			}
		},
		async fetchUserInfo({ commit }) {
			try {
				let res = await API.FetchUserInfo();
				commit("setUserInfo", res.data);
			} catch (e) {
				throw e.response.data
			}
		},
		async login({ dispatch }, data) {
			try {
				let res = await API.Login(data);
				let token = res.data;
				await dispatch("setAPIToken", token);
				localStorage.setItem("token", token);
				await dispatch("fetchUserInfo");
			} catch (e) {
				throw e.response.data;
			}
		},
		async updatePersonBasicProfile({ commit }, data) {
			try {
				commit("updateProfile", (await API.UpdatePersonBasicProfile(data)).data);
			} catch (e) {
				throw e.response.data;
			}
		},
		async newPersonJob({ commit }, data) {
			try {
				let res = await API.NewPersonJob(data);
				commit("updateJob", res.data);
			} catch (e) {
				throw e.response.data;
			}
		},
		async updatePersonJob({ commit }, data) {
			try {
				let res = await API.UpdatePersonJob(data);
				commit("updateJob", res.data);
			} catch (e) {
				throw e.response.data;
			}
		},
		async deletePersonJob({ commit }, id) {
			try {
				await API.DeletePersonJob(id);
				commit("deleteJob", id);
			} catch (e) {
				throw e.response.data;
			}
		},
		async changePassword({ }, data) {
			try {
				await API.ChangePassword(data);
			} catch (e) {
				console.log("e", e);
				throw e.response.data;
			}
		},
		async forgetPassword({ }, data) {
			try {
				await API.ForgetPassword(data);
			} catch (e) {
				console.log("e", e);
				throw e.response.data;
			}
		},
		async getSchool({ }, data) {
			try {
				let res = await API.GetSchool(data);
				return res.data;
			} catch (e) {
				console.log("error", e);
			}
		},
		cleanToken() {
			localStorage.removeItem("token");
			API.token = "";
		},
		setAPIToken({ }, token) {
			API.token = token;
		},
		async thirdPartLogin({ dispatch }, token) {
			try {
				await dispatch("setAPIToken", token);
				localStorage.setItem("token", token);
				await dispatch("fetchUserInfo");
			} catch (e) {
				throw e;
			}
		}
	}
};

export default UserModule;
